import { replaceHtmlEntities } from "@/shared/helpers/parse-html-value";
import { I_GENERIC_ITEMS } from "../model/interface/items.interface";

export interface CategorizedFeatures {
  closet: I_CategorizedFeatures[];
  condominiumData: I_CategorizedFeatures[];
  cabinets: I_CategorizedFeatures[];
  frames: I_CategorizedFeatures[];
  improvements: I_CategorizedFeatures[];
  floors: I_CategorizedFeatures[];
  doors: I_CategorizedFeatures[];
  roof: I_CategorizedFeatures[];
  location: I_CategorizedFeatures[];
  usage: I_CategorizedFeatures[];
  windows: I_CategorizedFeatures[];
  houseType: I_CategorizedFeatures[];
  roofForm: I_CategorizedFeatures[];
}

interface I_CategorizedFeatures extends I_GENERIC_ITEMS {
  extras: any;
}
function categorizeFeaturesHelper(
  data: any[],
  keyForValue = "id"
): CategorizedFeatures {
  const categorizedFeatures: Record<string, any> = {};

  data.forEach(item => {
    const name = item.name;

    if (typeof item.value == "string") {
      categorizedFeatures[name] = [
        {
          label: replaceHtmlEntities(item?.value),
          value: item.value,
          extra: item
        }
      ];
    } else {
      categorizedFeatures[name] = item?.values?.map((value: any) => ({
        label: replaceHtmlEntities(value.name),
        value: value[keyForValue],
        id: value[keyForValue],
        name: value.name,
        extra: value
      }));
    }
  });
  return {
    closet: categorizedFeatures?.Closets ?? [],
    condominiumData: categorizedFeatures["Datos Condominio"] ?? [],
    cabinets: categorizedFeatures?.Gabinetes ?? [],
    frames: categorizedFeatures?.Marcos ?? [],
    improvements: categorizedFeatures?.Mejoras ?? [],
    floors: categorizedFeatures?.Pisos ?? [],
    doors: categorizedFeatures?.Puertas ?? [],
    roof: categorizedFeatures?.Techo ?? [],
    location: categorizedFeatures["Ubicaci&oacute;n"] ?? [],
    usage: categorizedFeatures?.Uso ?? [],
    windows: categorizedFeatures?.Ventanas ?? [],
    houseType: categorizedFeatures?.Casa ?? [],
    roofForm: categorizedFeatures["Forma techo"] ?? []
  };
}

export default categorizeFeaturesHelper;
